import {
  Typography,
  Stack
} from "@mui/material";

const TripTimelineSpeedBox = (props) => {
  const { device, item = {}, apiLoading } = props;

  return (
    <Stack direction={`row`} justifyContent={`flex-end`} alignItems={`center`}>
      {
        (Number(device.overspeed_km) > 0) ? (
          <Typography style={{ color: Number(item.maxSpeedKm) >= 1.5 * Number(device.overspeed_km) ? '#FF0000' : (Number(item.maxSpeedKm) >= Number(device.overspeed_km) ? '#E97451' : null) }}>
            <b>{item.maxSpeed}</b> {item.speedUnitStr}
          </Typography>
        ) : (
          <Typography>
            <b>{item.maxSpeed}</b> {item.speedUnitStr}
          </Typography>
        )
      }
    </Stack>
  )
}

export default TripTimelineSpeedBox;
